import { parseQueryString } from "@aws-sdk/querystring-parser";
import { parse } from "url";
export var parseUrl = function parseUrl(url) {
  var _a = parse(url),
      _b = _a.hostname,
      hostname = _b === void 0 ? "localhost" : _b,
      _c = _a.pathname,
      pathname = _c === void 0 ? "/" : _c,
      port = _a.port,
      _d = _a.protocol,
      protocol = _d === void 0 ? "https:" : _d,
      search = _a.search;

  var query;

  if (search) {
    query = parseQueryString(search);
  }

  return {
    hostname: hostname,
    port: port ? parseInt(port) : undefined,
    protocol: protocol,
    path: pathname,
    query: query
  };
};